import { useEffect } from 'react';
import { useTheme } from '@/context/ThemeProvider';
import { Lightbulb } from 'lucide-react';

import { Button } from '@/components/ui/button';

const ORGANIZATION = 'sbccrm';

// Dropdown to toggle the theme
const FeaturebaseFeedbackWidget = () => {
  const { currentTheme } = useTheme();

  useEffect(() => {
    const win = window;
    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
      };
    }

    // Initialize with dynamic metadata only when we have valid data
    win.Featurebase(
      'initialize_feedback_widget',
      {
        organization: ORGANIZATION,
        theme: currentTheme,
        locale: 'en',
      },
      (err) => {
        if (err) {
          console.error(
            'Featurebase feedback widget initialization failed:',
            err
          );
        } else {
          console.log('Featurebase feedback widget initialized');
        }
      }
    );
  }, [currentTheme]);

  return (
    <>
      <div className='inline-flex h-11 w-11 items-center justify-center bg-background transition-colors disabled:pointer-events-none'>
        <Button
          data-featurebase-feedback
          variant='link'
          size='icon'
          title='Feedback'
          className='text-gray-400 hover:text-primary'
        >
          <Lightbulb className=' h-5 w-5' title='Feedback' />
        </Button>
      </div>
    </>
  );
};

export default FeaturebaseFeedbackWidget;
